import { Schedule } from "../../../../interfaces/src/lib/schedule.interface";


export function isStoreOpen(schedule: Schedule, currentTime: Date): boolean {
    const { openingTime, closingTime, previousClosingTime } = schedule;
  
    const isOpenInCurrentSchedule = currentTime >= openingTime && currentTime <= closingTime;
    const isOpenFromPreviousDay = previousClosingTime && currentTime <= previousClosingTime;
  
    return isOpenInCurrentSchedule || isOpenFromPreviousDay;
}
  